import { render } from "./KuaishouMiniappIntroduce.vue?vue&type=template&id=076e622d&scoped=true"
import script from "./KuaishouMiniappIntroduce.vue?vue&type=script&lang=js"
export * from "./KuaishouMiniappIntroduce.vue?vue&type=script&lang=js"

import "./KuaishouMiniappIntroduce.vue?vue&type=style&index=0&id=076e622d&lang=scss&scoped=true"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076e622d"]])

export default __exports__